import script from "./DomainStateChip.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainStateChip.vue?vue&type=script&setup=true&lang=js"

import "./DomainStateChip.vue?vue&type=style&index=0&id=7f8d368a&lang=scss"

const __exports__ = script;

export default __exports__